<div class="intuitive-order-container">
	<div class="select-procedure-button">
		<rx-procedure-button
			[selectedProcedure]="selectedProcedure$ | async"
			[expanded]="proceduresSelectExpanded"
			[canExpand]="canChangeProcedure$ | async"
			[readOnly]="!!(isReadOnly$ | async)"
			[animationElement]="expansionPanelRef"
			(buttonClicked)="showSelectPanel()"
		></rx-procedure-button>
	</div>

	<tlk-card *ngIf="(sendToState$ | async)?.isVisible" [padding]="0" class="intuitive-inline-card send-to" data-testid="order-send-to">
		<rx-favorite-selector
			tlkCardContent
			data-testid="order-send-to-lab"
			class="intuitive-inline-card__content"
				[id]="'sendTo'"
				[label]="'OrderSection.SendTo' | translate"
				[formControl]="sendToControl"
				[options]="availableLabs$ | async"
				name="sendToControl"
				[isCancellable]="!!(isSendToCancellable$ | async)"
				[isDisabled]="!(sendToState$ | async)?.isEnabled || !!(isReadOnly$ | async)"
				[isRequired]="!!(sendToState$ | async)?.isRequired"
				[isReadOnly]="!!(isReadOnly$ | async)"
				[favoriteName]="favoriteSendTo"
				[enableSimpleMode]="!!(isNotDoctor$ | async)"
			></rx-favorite-selector>
	</tlk-card>

	<tlk-card *ngIf="(dueDateState$ | async)?.isVisible" [padding]="0" class="intuitive-inline-card due-date">
		<rx-due-date-picker
			tlkCardContent
			class="intuitive-inline-card__content"
			[isRequired]="!!(dueDateState$ | async)?.isRequired"
			[formControl]="dueDateControl"
			[isCancellable]="!(dueDateState$ | async)?.isRequired"
			[isReadOnly]="!!(isReadOnly$ | async)"
			[minimalAvailableDueDate]="minimalAvailableDueDate$ | async"
			[useIntuitiveCalendarIcon]="true"
			name="dueDateControl"
			[rxIsDisabled]="!(dueDateState$ | async)?.isEnabled"
			(rxIsDisabledEvent)="clearControl(dueDateControl)"
		></rx-due-date-picker>
	</tlk-card>
</div>
<tlk-expansion-area [expanded]="proceduresSelectExpanded" [removeWhenCollapsed]="false">
	<ng-template tlkExpansionContent>
		<div #expansionPanel class="expansion-panel-wrapper">
			<tlk-card [padding]="0" class="select-procedure-panel">
				<rx-procedure-tiles
					tlkCardContent
					[procedures]="procedures$ | async"
					[selectedProcedureId]="(selectedProcedureId$ | async) ?? null"
					(procedureChanged)="onProcedureChanged($event)"
					(changeProcedureCancelled)="onChangeProcedureCancelled()"
					[promptOnChange]="true">
				</rx-procedure-tiles>
			</tlk-card>
		</div>
	</ng-template>
</tlk-expansion-area>

